// Progress-bar screens (levelblit.c ProgressBarScreen/LoadingScreen/SavingScreen).
// Generation/serialisation run synchronously, so these draw into the framebuffer
// but do not present by themselves; the surrounding sequence presents a frame.

import { screen, fillSurface, DrawRect, draw_text } from '../render/surface';
import { executeScene } from '../render/scene';
import { S } from './constants';
import { clearInput } from './input';
import { G } from './state';

const tr = Math.trunc;

export function ProgressBarScreen(
  part: number,
  progress: number,
  message: string,
  t_parts: number
): void {
  executeScene(() => {
    fillSurface(screen, 0);
    DrawRect(S(200), S(217), S(240), S(50), 80);
    DrawRect(S(202), S(219), S(236), S(46), 20);
    draw_text(S(232), S(228), message, 255);
    DrawRect(S(232), S(244), S(176), S(12), 128);
    DrawRect(S(234), S(246), S(172), S(8), 0);
    const amt = tr((S(172) * progress) / t_parts + (S(172) / t_parts) * part);
    if (amt > 0) {
      DrawRect(S(234), S(246), amt, S(8), 200);
    }
  });
}

export function LoadingScreen(part: number, progress: number): void {
  const t_parts = G.game_load ? 5.0 : 3.0;
  ProgressBarScreen(part, progress, 'Loading... please wait', t_parts);
  clearInput();
}

export function SavingScreen(part: number, progress: number): void {
  ProgressBarScreen(part, progress, 'Saving... please wait', 4.0);
  clearInput();
}
